const LETTERS = 'A-Za-zÀ-ÖØ-öø-ÿ';
const LETTERS_REGEX = new RegExp(`[${LETTERS}]`);

// referring to https://github.com/GoogleChrome/chromium-dashboard/issues/3106, "-" has to be escaped because of "v" option
export const PATTERNS = {
  houseNumber: String.raw`^[${LETTERS}\d](?:[\-,.'${LETTERS}\d\s]){0,9}$`,
  name: String.raw`^[${LETTERS}](?:[\-.'${LETTERS}\s]){1,49}$`,
  phoneNumber: String.raw`^(?:\+\d|0)(?: ?(- ?)?\d){5,}$`,
  zipCode: String.raw`^\d{5}$`,
} as const;

// there ssems to be no easier way to make input patterns case-insensitive
export const toPatternIgnoringCase = (text: string) =>
  [...text]
    .map((char) =>
      LETTERS_REGEX.test(char) ? `[${char.toLocaleUpperCase()}${char.toLocaleLowerCase()}]` : RegExp.escape(char),
    )
    .join('');
